<h2><text key="HEADING"></text></h2>

<div class="row">
  <div class="col-lg-10 report-header-section-filters">
    <formly [form]="form" [fields]="fields" [model]="model">
      <button class="btn btn-primary" [busyButton]="loading" (click)="startLoad()"><span translate>GA.BUTTONS.LOAD</span></button>
      <button class="btn btn-danger cancel-button" *ngIf="loading" (click)="stopLoad()"><span translate>GA.BUTTONS.STOP_SEARCH</span></button>
    </formly>
  </div>
</div>

<collapsible-pane *ngFor="let chartReport of chartReports" [title]="chartReport.title | translate" [collapsed]="chartReport.collapsed" (onChange)="onChangeCollapsed($event, chartReport)">
  <div class="collapsible-title-extra">
    <editable-text [key]="chartReport.id" menu="title" highlight="parent parent parent h3 a:eq(0)"></editable-text>

    <span class="detailed-report-link" *ngIf="chartReport.params">
      <a uiSref="main.reports" [uiParams]="chartReport.params" target="_blank"><i class="fa fa-table"></i></a>
    </span>
  </div>

  <div class="row" *ngIf="chartReport.listFaqs">
    <div class="col-md-12">
      <ng-container *ngFor="let faqCode of chartReport.listFaqs">
        <faq-link [faqCode]="faqCode"></faq-link>
      </ng-container>
    </div>
  </div>
  <div class="row" *ngIf="!chartReport.listFaqs">
    <div class="col-lg-6">
      <embedded-report
        [sectionId]="chartReport.id"
        [reportId]="chartReportId"
        [reportMetadata]="chartReport.metadata"
        [reportDataLoading]="loading"
        [reportData]="reportData"
        [reportSort]="chartReport.sort"
        (onGridReady)="onGridReady($event)">
      </embedded-report>
    </div>
    <div class="col-lg-6">
      <button class="btn btn-sm btn-default margin-left-md enlarge-chart" (click)="onEnlargeChart(chartReport)" *ngIf="chart.innerHTML"><i class="fa fa-arrows-alt"></i></button>
      <div [id]="chartReport.id + '_CHART'" class="chart-container" #chart></div>
    </div>
  </div>
</collapsible-pane>